import { uiToken } from '~/shared/constants/uiToken';
import { InputField } from '~/shared/ui/InputField/InputField';

import { useLocalization } from '../../../../../../localization/localization';

// @ts-expect-error
export const SearchInput = (props: InputHTMLAttributes<HTMLInputElement>) => {
  const { error, onChange, ...inputProps } = props;

  const { t } = useLocalization();

  return (
    <InputField
      error={error}
      inputProps={{
        ...inputProps,
        placeholder: t('Search'),
        type: 'text',
        inputStyle: {
          height: '32px',
          backgroundColor: '#252525',
          border: `1px solid ${uiToken.color.border.default}`,
        },
        onChange: (e) => {
          onChange(e.target.value.trim());
        },
      }}
    />
  );
};
